import { NavigateNext } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import React from 'react';
import styles from './styles.module.css';

const Breadcrumbs = ({
  listItems,
  separator = <NavigateNext className={styles.navNext} fontSize='default' />,
}) => {
  const separatorType = 'separator';

  const createListItemsWithSeparator = () => {
    const listItemsWithSeparator = listItems.flatMap((item) => [item, { type: separatorType }]);
    listItemsWithSeparator.pop();
    return listItemsWithSeparator;
  };

  const createListContent = ({ type, text, to = undefined }) => {
    switch (type) {
      case 'link':
        return <Link className={styles.item} to={to}>{text}</Link>;
      case 'text':
        return <span className={styles.item}>{text}</span>;
      case separatorType:
        return separator;
      default:
        return <></>;
    }
  };

  return (
    <ol className={styles.breadcrumb}>
      {createListItemsWithSeparator().map((list, index) => (
        <li className={styles.breadcrumbList} key={index}>
          {createListContent(list)}
        </li>
      ))}
    </ol>
  );
};

export default Breadcrumbs;
